import { Box} from '@mui/material'
import { ReportingEsrsSixTable } from '../../../presentation-components/reporting-components/esrs/esrs-six/reporting-esrs-six-table';
import { useParams } from 'react-router-dom';
import { useContext } from 'react';
import { ReportPeriodContext } from '../../../../context/report-periods/report-periods';
import { PageOuterContainer } from '../../../../root-components/layouts/page-outer-container';
import { PageHeading } from '../../../presentation-components/display-elements-components/page-heading';

export const ReportingEsrsSixPage = () => {
  const { reportPeriodId } = useParams();
  const reportPeriodContext = useContext(ReportPeriodContext)
  
  return (
    <PageOuterContainer>
      <PageHeading
        title={`E1-6, Gross Scopes 1, 2 & 3 and Total Greenhouse Gas Emissions ${reportPeriodContext.allReportPeriods.find(reportPeriod => reportPeriod.id === reportPeriodId)?.friendlyName}`}
        includeBackButton={true}
        // backButtonLink={`/reporting/european-sustainability-reporting-standard/${reportPeriodId}`}
        backButtonLink='/reporting/european-sustainability-reporting-standard'
        backButtonText='Back to ESRS reporting'
        hasTabs={false}
      />
      {reportPeriodId && <Box>
        {/* <Typography variant='h6' sx={{ mb: 1 }}>Table of Scope Data</Typography> */}
        <ReportingEsrsSixTable reportPeriodId={reportPeriodId} />
      </Box>}
    </PageOuterContainer>
  )
}